// extracted by mini-css-extract-plugin
export default {"title":"NdsSuccessSend_title__vwMum","description":"NdsSuccessSend_description__3C05b"};